import classNames from 'classnames'
import { ReactNode } from 'react'

export const MultipleChoiceButton = ({
  children,
  onClick,
  selected,
}: {
  children: ReactNode
  onClick: Function
  selected: boolean
}) => {
  return (
    <button
      onClick={() => onClick()}
      type="button"
      className={classNames(
        'active rounded-lg border overflow-hidden relative flex flex-col hover:ring-2 hover:ring-indigo-700 p-5',
        {
          'ring-2 ring-indigo-700 bg-indigo-50/30 shadow-inner border-indigo-700 bg-white':
            selected,
          'border-gray-300 shadow-sm bg-gray-50': !selected,
        }
      )}
    >
      {children}
    </button>
  )
}
